import { NavigateByPathCommand } from '../commands/navigate-by-path.command.model';
import { OpenInvationModalCommand } from '../commands/open-invitation-modal.command.model';
import { OperationType } from '../operation-type.enum';
import { OperationWithCommand } from '../operation-with-command.model';
import { InviteDispatcherPayload } from '../payloads/invite-dispatcher.payload.model';

export class InviteDispatcherOperation extends OperationWithCommand {
    static operationTypeStatic = OperationType.InviteDispatcher;
    operationType = OperationType.InviteDispatcher;
    payload = new InviteDispatcherPayload();
    queueCommands = [
      new NavigateByPathCommand(),
      new OpenInvationModalCommand(),
    ];
}
